export const TARGETING_COMMON_KEY = 'targeting-common';
export const TARGETING_API_BASE_URL = '/api/targeting';
export const PAGE_SIZE = 50;
